import VueRouter from "vue-router";
import { ModalResult } from "./modal-result.model";

interface ModalListener {
  onShow: (
    z_index: number,
    cmp: unknown,
    data?: unknown
  ) => Promise<ModalResult>;
  onHide: () => Promise<void>;
  onForceClose: () => Promise<void>;
}
const BASE_MODAL_Z_INDEX = 200;
let current_z_index_at_front = BASE_MODAL_Z_INDEX;

export const is_modal_on_top = (htmlEl: HTMLElement) => {
  const { zIndex } = getComputedStyle(htmlEl);
  return +zIndex >= current_z_index_at_front;
};

export const UseModal = (function createModal() {
  const root_modals: Array<{
    is_active: boolean;
    listener: ModalListener;
  }> = [];

  function setRootModal(listener: ModalListener) {
    root_modals.push({ listener, is_active: false });
  }

  async function hide(index: number) {
    await root_modals[index].listener.onHide();
    root_modals[index].is_active = false;
    --current_z_index_at_front;
  }

  function hide_quick(index: number) {
    root_modals[index].is_active = false;
    root_modals[index].listener.onHide();
  }

  async function show<T>(cmp: unknown, data?: unknown): Promise<ModalResult> {
    const modal_index = root_modals.findIndex((l) => !l.is_active);
    console.log("modal_index ::", modal_index);
    root_modals[modal_index].is_active = true;
    current_z_index_at_front++;
    const result = await root_modals[modal_index].listener.onShow(
      current_z_index_at_front,
      cmp,
      data
    );
    if (result.type === "swap") {
      hide_quick(modal_index);
    } else {
      await hide(modal_index);
    }
    const active_count = root_modals.filter((d) => d.is_active).length;
    if (active_count === 0) {
      current_z_index_at_front = BASE_MODAL_Z_INDEX;
    }
    return result;
  }

  async function showSimple<T>(config: {
    title: string;
    desc: string;
    submitBtnText?: string;
    cancelBtnText?: string;
    width?: string;
    is_destructive?: boolean;
  }): Promise<ModalResult> {
    const Modal = () => ({
      component: import("./Modal.vue"),
    });
    return await show(Modal, config);
  }

  const set_router = (router: VueRouter) => {
    router.beforeEach((to, from, next) => {
      const active_modals = root_modals.filter((l) => l.is_active);
      if (active_modals.length > 0) {
        active_modals.forEach((l) => {
          l.listener.onHide();
          l.is_active = false;
        });
      }
      next();
    });
  };

  const force_close_all = () => {
    root_modals.forEach((r) => r.listener.onForceClose());
  };

  return () => {
    return {
      set_router,
      setRootModal,
      show,
      showSimple,
      force_close_all,
    };
  };
})();
